import React, { useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import Table, { dateFormatter } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import { getQuizzes } from "../../../../api/quiz";
import { getGames } from "../../../../api/game";
import { alertError } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";

/** Muestra exactamente los 13 que devuelve la API (con placeholders "— Sin asignar —" si faltan). */
function getData(quizzes) {
	if (!Array.isArray(quizzes)) return [];
	return quizzes.map((quiz, index) => {
		const scenario = quiz.scenario;
		const isPlaceholder = !!quiz.placeholder;
		return {
			id: quiz._id != null ? quiz._id : `slot-${index}`,
			name: quiz.fullName || "—",
			scenario: scenario ? (scenario.fullName || scenario._id || "") : "",
			createdAt: quiz.createdAt,
			isPlaceholder,
		};
	});
}

const QUIZZES_GAME_STORAGE_KEY = "quizzes_selected_game_id";

export default function QuizzesPage() {
	const [games, setGames] = useState([]);
	const [selectedGameId, setSelectedGameId] = useState(() =>
		typeof sessionStorage !== "undefined" ? sessionStorage.getItem(QUIZZES_GAME_STORAGE_KEY) || "" : ""
	);
	const [data, setData] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();

	useEffect(() => {
		if (selectedGameId && typeof sessionStorage !== "undefined") {
			sessionStorage.setItem(QUIZZES_GAME_STORAGE_KEY, selectedGameId);
		}
	}, [selectedGameId]);

	useEffect(() => {
		getGames()
			.then((res) => {
				if (res.status === 200 && res.data && res.data.length) {
					const list = res.data;
					setGames(list);
					setSelectedGameId((current) => {
						const valid = current && list.some((g) => g._id === current);
						return valid ? current : (list[0] && list[0]._id) || "";
					});
				}
			})
			.catch(() => {});
	}, []);

	function editButtonFormatter(cell, row) {
		if (row && row.isPlaceholder) return "—";
		return (
			<Tooltip title="Editar contenido (p. ej. pruebas)">
				<Button size="small" onClick={() => history.push("/quiz/" + cell + "/edit")}>
					<EditIcon />
				</Button>
			</Tooltip>
		);
	}

	function answersButtonFormatter(cell, row) {
		if (row && row.isPlaceholder) return "—";
		return (
			<Tooltip title="Ver respuestas">
				<Button size="small" onClick={() => history.push("/quiz/" + cell)}>
					<EqualizerIcon style={{ marginRight: "6px", fontSize: 18 }} />
					Answers
				</Button>
			</Tooltip>
		);
	}

	function createdAtFormatter(cell, row) {
		if (row && row.isPlaceholder) return "—";
		return dateFormatter(cell);
	}

	const columns = [
		{ dataField: "name", text: "Full name", sort: true },
		{ dataField: "scenario", text: "Scenario", sort: true },
		{
			dataField: "createdAt",
			text: "Created at",
			align: "center",
			headerAlign: "center",
			formatter: createdAtFormatter,
			sort: true,
		},
		{
			dataField: "id",
			text: "Editar",
			align: "center",
			headerAlign: "center",
			formatter: editButtonFormatter,
		},
		{
			dataField: "id",
			text: "Statistics",
			align: "center",
			headerAlign: "center",
			formatter: answersButtonFormatter,
		},
	];

	useEffect(() => {
		if (!selectedGameId) return;
		const params = { game: selectedGameId };

		getQuizzes(params)
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data || []));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get quizzes.",
				});
			});
	}, [refresh, selectedGameId]);

	return (
		<>
			<Card>
				<CardHeader title="Quizzes list"></CardHeader>
				<CardBody>
					<div className="form-group mb-4">
						<label htmlFor="quizzes-game-select" className="font-weight-bold">
							Select a game
						</label>
						<select
							id="quizzes-game-select"
							className="form-control"
							style={{ maxWidth: 320 }}
							value={selectedGameId}
							onChange={(e) => setSelectedGameId(e.target.value)}
						>
							{games.map((game) => (
								<option key={game._id} value={game._id}>
									{game.fullName}
								</option>
							))}
						</select>
						<small className="form-text text-muted">
							Quizzes de este juego (copia de los globales al crear el juego).
						</small>
					</div>
					<Table data={data} columns={columns} />
				</CardBody>
			</Card>
		</>
	);
}
